(function () {
  "use strict";

  var initialized = new WeakSet();
  var configuratorInstances = new WeakMap();

  var FIELD_KEYS = {
    frame_type: ["frame_type"],
    jamb_size: ["jamb_size"],
    frame_lock_prep: ["frame_lock_prep"],
    frame_swing: ["frame_swing"],
    frame_hinges: ["frame_hinges"],
    frame_hinge_finish: ["frame_hinge_finish"],
    frame_custom_height_toggle: ["frame_custom_height_toggle"],
    frame_custom_height_value: ["frame_custom_height_value"],
    prep_hinge_toggle: ["prep_hinge_toggle"],
    prep_hinge_type: ["prep_hinge_type"],
    prep_hinge_custom_measurements: [
      "top_hinge_top",
      "middle_hinge_top",
      "bottom_hinge_top"
    ],
    prep_lock_toggle: ["prep_lock_toggle"],
    prep_lock_type: ["prep_lock_type"],
    prep_lock_custom_measurement: ["lock_centre_location"],
    prep_swing: ["prep_swing"],
    prep_hinges: ["prep_hinges"],
    prep_hinge_finish: ["prep_hinge_finish"],
    prep_custom_height_toggle: ["prep_custom_height_toggle"],
    prep_custom_height_value: ["prep_custom_height_value"],
    only_custom_height_value: ["only_custom_height_value"]
  };

  var PATH_STEP_KEY_ORDER = {
    frame_set: [
      "frame_type",
      "jamb_size",
      "frame_lock_prep",
      "frame_swing",
      "frame_hinges",
      "frame_hinge_finish",
      "frame_custom_height_toggle",
      "frame_custom_height_value"
    ],
    door_prep: [
      "prep_hinge_toggle",
      "prep_hinge_type",
      "top_hinge_top",
      "middle_hinge_top",
      "bottom_hinge_top",
      "prep_lock_toggle",
      "prep_lock_type",
      "lock_centre_location",
      "prep_swing",
      "prep_hinges",
      "prep_hinge_finish",
      "prep_custom_height_toggle",
      "prep_custom_height_value"
    ],
    custom_height: ["only_custom_height_value"]
  };

  var STATE_KEY_TO_FIELD = (function () {
    var mapping = {};
    Object.keys(FIELD_KEYS).forEach(function (fieldName) {
      var keys = FIELD_KEYS[fieldName] || [];
      keys.forEach(function (key) {
        if (!mapping[key]) mapping[key] = fieldName;
      });
    });
    return mapping;
  })();

  var DOUBLE_DOOR_VALUE = "Double Door";
  var DOUBLE_MULTIPLIED_ADDON_KEYS = {
    prep_standard: true,
    prep_custom: true,
    hinges_black: true,
    hinges_satin_nickel: true,
    custom_height_cutdown: true
  };
  var INTERNAL_PROPERTY_BLOCKLIST = {
    "_Door Main Item": true,
    "_Door Main Multiplier": true,
    "_Door Add-On": true,
    "_Door Add-On Label": true,
    "_Door Add-On Key": true,
    "_Door Add-On Multiplier": true,
    "_Door Config ID": true,
    "_door_id": true,
    "_parent_door_id": true
  };
  var SIZE_WARNING_MESSAGE = "Please select a door size!";

  function asMoney(cents) {
    if (
      window.theme &&
      typeof window.theme.formatMoney === "function" &&
      window.theme.moneyFormat
    ) {
      if (
        window.theme.settings &&
        window.theme.settings.currency_code_enable &&
        window.theme.moneyWithCurrencyFormat
      ) {
        return window.theme.formatMoney(cents, window.theme.moneyWithCurrencyFormat);
      }

      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function parseNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed)) return fallback;
    return parsed;
  }

  function parseDimension(rawValue) {
    var raw = String(rawValue || "")
      .replace(/\b(inches|inch|in)\b/gi, "")
      .replace(/[^0-9./\-\s]/g, "")
      .trim()
      .replace(/\s+/g, " ");

    if (!raw) return { valid: false, decimal: null };

    if (/^\d+(\.\d+)?$/.test(raw)) {
      return { valid: true, decimal: parseFloat(raw) };
    }

    var mixed = raw.match(/^(\d+)\s*[- ]\s*(\d+)\s*\/\s*(\d+)$/);
    if (mixed) {
      var whole = parseInt(mixed[1], 10);
      var numerator = parseInt(mixed[2], 10);
      var denominator = parseInt(mixed[3], 10);

      if (!denominator) return { valid: false, decimal: null };

      return { valid: true, decimal: whole + numerator / denominator };
    }

    return { valid: false, decimal: null };
  }

  function DoorAddonConfigurator(container) {
    this.container = container;
    this.productInfo = container.closest("product-info");
    this.formId = container.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    if (!this.form) return;

    this.state = { path: "" };
    this.fields = {};
    this.errors = {};
    this.addonProducts = this.readAddonProducts();
    this.baseVariantPrices = this.readBaseVariantPrices();
    this.pricingList = this.container.querySelector("[data-addon-pricing-list]");
    this.pricingEmpty = this.container.querySelector("[data-addon-pricing-empty]");
    this.pricingTotal = this.container.querySelector("[data-addon-pricing-total]");
    this.submitError = this.container.querySelector("[data-submit-error]");
    this.pathResetButton = this.container.querySelector("[data-path-reset]");
    this.expandedContent = this.container.querySelector("[data-expanded-content]");
    this.submitButton = this.form.querySelector('button[type="submit"][name="add"]');
    this.isCartDrawer = Boolean(
      window.theme &&
        window.theme.settings &&
        window.theme.settings.cartType === "drawer" &&
        document.querySelector("cart-element[data-cart-drawer]")
    );

    this.container.querySelectorAll("[data-field]").forEach(
      function (el) {
        this.fields[el.dataset.field] = el;
      }.bind(this)
    );

    this.container.querySelectorAll("[data-error-for]").forEach(
      function (el) {
        this.errors[el.dataset.errorFor] = el;
      }.bind(this)
    );

    this.setupAccessibility();
    this.bindEvents();
    this.subscribeVariantChanges();
    this.render();
  }

  DoorAddonConfigurator.prototype.setupAccessibility = function () {
    DoorAddonConfigurator.a11yInstances = (DoorAddonConfigurator.a11yInstances || 0) + 1;
    var uid = DoorAddonConfigurator.a11yInstances;

    // Validation errors announce to assistive tech and get ids so the
    // matching inputs can reference them.
    Object.keys(this.errors).forEach(
      function (key) {
        var errorEl = this.errors[key];
        if (!errorEl.id) {
          errorEl.id = "door-addon-error-" + uid + "-" + key.replace(/[^a-zA-Z0-9_-]/g, "");
        }
        errorEl.setAttribute("role", "alert");
      }.bind(this)
    );
    if (this.submitError) this.submitError.setAttribute("role", "alert");

    this.container.querySelectorAll("[data-input]").forEach(
      function (input) {
        var errorEl = this.errors[input.dataset.input];
        if (errorEl) input.setAttribute("aria-describedby", errorEl.id);
      }.bind(this)
    );
    var photoInput = this.getHingePhotoInput();
    if (photoInput && this.errors.hinge_photo) {
      photoInput.setAttribute("aria-describedby", this.errors.hinge_photo.id);
    }

    this.container
      .querySelectorAll("[data-choice], [data-path-option]")
      .forEach(function (button) {
        button.setAttribute(
          "aria-pressed",
          button.classList.contains("is-selected") ? "true" : "false"
        );
      });

    // Tie each step question to its group of chips.
    var labelIndex = 0;
    this.container.querySelectorAll("[data-field]").forEach(function (field) {
      var label = field.querySelector(".door-addon-configurator__label");
      var row = field.querySelector("[data-control]");
      if (!label || !row) return;
      labelIndex += 1;
      if (!label.id) label.id = "door-addon-label-" + uid + "-" + labelIndex;
      row.setAttribute("role", "group");
      row.setAttribute("aria-labelledby", label.id);
    });
    var pathIntro = this.container.querySelector(".door-addon-configurator__intro");
    var pathRow = this.container.querySelector(".door-addon-configurator__path-row");
    if (pathIntro && pathRow) {
      if (!pathIntro.id) pathIntro.id = "door-addon-label-" + uid + "-path";
      pathRow.setAttribute("role", "group");
      pathRow.setAttribute("aria-labelledby", pathIntro.id);
    }
  };

  DoorAddonConfigurator.prototype.readAddonProducts = function () {
    var jsonEl = this.container.querySelector("[data-addon-products]");
    if (!jsonEl) return {};

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return {};
    }
  };

  DoorAddonConfigurator.prototype.readBaseVariantPrices = function () {
    var jsonEl = this.container.querySelector("[data-base-variant-prices]");
    if (!jsonEl) return {};

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return {};
    }
  };

  DoorAddonConfigurator.prototype.subscribeVariantChanges = function () {
    if (
      !window.subscribe ||
      !window.theme ||
      !window.theme.PUB_SUB_EVENTS ||
      !window.theme.PUB_SUB_EVENTS.variantChange
    ) {
      return;
    }

    var sectionId = this.productInfo
      ? this.productInfo.dataset.section || this.productInfo.dataset.originalSection
      : null;

    this.variantChangeUnsubscriber = window.subscribe(
      window.theme.PUB_SUB_EVENTS.variantChange,
      function (payload) {
        if (!document.body.contains(this.container)) return;
        var eventSectionId = payload && payload.data ? payload.data.sectionId : null;
        if (sectionId && eventSectionId && sectionId !== eventSectionId) return;
        this.updatePricing();
      }.bind(this)
    );
  };

  DoorAddonConfigurator.prototype.bindEvents = function () {
    this.container.addEventListener(
      "click",
      function (event) {
        var pathButton = event.target.closest("[data-path-option]");
        if (pathButton) {
          this.selectPath(pathButton.value);
          return;
        }

        var resetButton = event.target.closest("[data-path-reset]");
        if (resetButton) {
          this.animateResetToBlank();
          return;
        }

        var choiceButton = event.target.closest("[data-choice]");
        if (!choiceButton) return;

        var control = choiceButton.closest("[data-control]");
        if (!control) return;

        var selectedValue =
          choiceButton.value ||
          choiceButton.getAttribute("value") ||
          choiceButton.dataset.choice;
        this.setControlValue(control.dataset.control, selectedValue);
      }.bind(this)
    );

    this.container.addEventListener(
      "input",
      function (event) {
        var input = event.target.closest("[data-input]");
        if (!input) return;
        this.state[input.dataset.input] = input.value.trim();
        this.hideError(input.dataset.input);
        this.hideSubmitError();
        this.updatePricing();
      }.bind(this)
    );

    this.container.addEventListener(
      "change",
      function (event) {
        var photoInput = event.target.closest("[data-hinge-photo-input]");
        if (!photoInput) return;
        this.handleHingePhotoChange(photoInput);
      }.bind(this)
    );

    if (this.productInfo) {
      this.productInfo.addEventListener(
        "change",
        function () {
          this.updatePricing();
        }.bind(this)
      );
    }

    this.form.addEventListener(
      "change",
      function (event) {
        var target = event.target;
        if (!target) return;
        if (target.matches("[name='id'], [name='quantity'], [data-quantity-field]")) {
          this.updatePricing();
        }
      }.bind(this)
    );

    this.form.addEventListener(
      "input",
      function (event) {
        var target = event.target;
        if (!target) return;
        if (target.matches("[name='quantity'], [data-quantity-field]")) {
          this.updatePricing();
        }
      }.bind(this)
    );

    this.bindQuantityListeners();

    this.form.addEventListener(
      "submit",
      function (event) {
        // If no add-on path is selected, keep native theme behavior.
        if (!this.state.path) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.hideSubmitError();

        var validation = this.validate();
        if (!validation.valid) {
          this.showSubmitError(validation.message);
          return;
        }

        var payload = this.buildCartPayload(validation.properties);
        if (!payload.valid) {
          if (payload.code === "missing_variant") {
            this.showSizeWarningState();
            this.hideSubmitError();
            return;
          }
          this.showSubmitError(payload.message);
          return;
        }

        if (payload.hingePhotoFile) {
          this.submitCartPayloadWithPhoto(payload.items, payload.hingePhotoFile);
        } else {
          this.submitCartPayload(payload.items);
        }
      }.bind(this),
      true
    );
  };

  DoorAddonConfigurator.prototype.selectPath = function (path) {
    if (!path) return;
    if (this.state.path === path) return;

    this.clearAllValues();
    this.state.path = path;
    this.render();
  };

  DoorAddonConfigurator.prototype.resetAll = function () {
    this.clearAllValues();
    this.clearHingePhoto();
    this.render();
  };

  DoorAddonConfigurator.prototype.clearSelectedStatesForCollapse = function () {
    this.container
      .querySelectorAll("[data-path-option].is-selected, [data-choice].is-selected")
      .forEach(function (button) {
        button.classList.remove("is-selected");
        button.setAttribute("aria-pressed", "false");
      });

    if (this.pathResetButton) {
      this.pathResetButton.classList.add("is-hidden");
    }

    this.hideSubmitError();
  };

  DoorAddonConfigurator.prototype.clearPricingBeforeCollapse = function () {
    if (!this.pricingList || !this.pricingEmpty || !this.pricingTotal) return;

    this.pricingList.innerHTML = "";
    this.pricingEmpty.style.display = "";
    this.pricingTotal.textContent = asMoney(0);
  };

  DoorAddonConfigurator.prototype.animateResetToBlank = function () {
    var container = this.container;
    var expanded = this.expandedContent;
    if (!container || !expanded) {
      this.resetAll();
      return;
    }

    if (container.classList.contains("is-resetting")) return;

    var startHeight = expanded.scrollHeight;
    if (startHeight < 1) {
      this.resetAll();
      return;
    }

    // Remove active visual states and pricing before collapse starts.
    var resetHadFocus = document.activeElement === this.pathResetButton;
    this.clearSelectedStatesForCollapse();
    this.clearPricingBeforeCollapse();
    if (resetHadFocus) {
      var firstPathOption = container.querySelector("[data-path-option]");
      if (firstPathOption) firstPathOption.focus({ preventScroll: true });
    }
    this.isResetCollapseInProgress = true;

    container.classList.add("is-resetting");
    expanded.classList.add("is-collapsing-reset");
    expanded.style.height = startHeight + "px";
    expanded.style.overflow = "hidden";
    expanded.style.willChange = "height";

    // Force layout so collapse always starts from the current expanded height.
    expanded.getBoundingClientRect();
    expanded.style.transition = "height 420ms cubic-bezier(0.22, 1, 0.36, 1)";
    expanded.style.height = "0px";

    var isCleaned = false;
    var cleanup = function () {
      if (isCleaned) return;
      isCleaned = true;
      this.isResetCollapseInProgress = false;
      this.resetAll();
      expanded.style.transition = "";
      expanded.style.height = "";
      expanded.style.overflow = "";
      expanded.style.willChange = "";
      expanded.classList.remove("is-collapsing-reset");
      container.classList.remove("is-resetting");
      expanded.removeEventListener("transitionend", onEnd);
    }.bind(this);

    var onEnd = function (event) {
      if (event.target !== expanded || event.propertyName !== "height") return;
      cleanup();
    };

    expanded.addEventListener("transitionend", onEnd);
    setTimeout(cleanup, 520);
  };

  DoorAddonConfigurator.prototype.clearAllValues = function () {
    this.state = { path: "" };
    this.container.querySelectorAll("[data-choice]").forEach(function (button) {
      button.classList.remove("is-selected");
      button.setAttribute("aria-pressed", "false");
    });
    this.container.querySelectorAll("[data-input]").forEach(function (input) {
      input.value = "";
    });
    this.clearHingePhoto();
    this.clearErrors();
    this.hideSubmitError();
    this.clearSizeWarningState();
  };

  DoorAddonConfigurator.prototype.setControlValue = function (controlName, value) {
    var previousValue = this.state[controlName];
    if (previousValue === value) return;

    this.state[controlName] = value;
    this.resetDownstreamFromControl(controlName);
    this.hideSubmitError();

    var control = this.container.querySelector('[data-control="' + controlName + '"]');
    if (control) {
      control.querySelectorAll("[data-choice]").forEach(function (button) {
        var buttonValue =
          button.value ||
          button.getAttribute("value") ||
          button.dataset.choice;
        button.classList.toggle("is-selected", buttonValue === value);
        button.setAttribute("aria-pressed", buttonValue === value ? "true" : "false");
      });
    }

    this.render();
  };

  DoorAddonConfigurator.prototype.resetDownstreamFromControl = function (controlName) {
    var path = this.state.path;
    if (!path) return;

    var stepOrder = PATH_STEP_KEY_ORDER[path];
    if (!stepOrder || !stepOrder.length) return;

    var changedIndex = stepOrder.indexOf(controlName);
    if (changedIndex === -1) return;

    var clearedFields = {};

    for (var i = changedIndex + 1; i < stepOrder.length; i++) {
      var key = stepOrder[i];

      delete this.state[key];
      this.hideError(key);

      var fieldName = STATE_KEY_TO_FIELD[key];
      if (!fieldName || clearedFields[fieldName]) continue;

      this.clearField(fieldName);
      clearedFields[fieldName] = true;
    }
  };

  DoorAddonConfigurator.prototype.showSizeWarningState = function () {
    if (!this.submitButton || !document.body.contains(this.submitButton)) {
      this.submitButton = this.form.querySelector('button[type="submit"][name="add"]');
    }

    if (!this.submitButton) return;

    var textEl = this.submitButton.querySelector("[data-add-to-cart-text]");
    if (!textEl) return;

    this.submitButton.classList.remove("is-loading");
    this.submitButton.classList.remove("is-success");
    this.submitButton.removeAttribute("disabled");
    textEl.classList.add("is-size-warning");
    textEl.setAttribute("data-size-warning-text", SIZE_WARNING_MESSAGE);
  };

  DoorAddonConfigurator.prototype.clearSizeWarningState = function () {
    if (!this.submitButton || !document.body.contains(this.submitButton)) {
      this.submitButton = this.form.querySelector('button[type="submit"][name="add"]');
    }

    if (!this.submitButton) return;

    var textEl = this.submitButton.querySelector("[data-add-to-cart-text]");
    if (!textEl) return;

    textEl.classList.remove("is-size-warning");
    textEl.removeAttribute("data-size-warning-text");
  };

  DoorAddonConfigurator.prototype.setFieldVisibility = function (fieldName, visible) {
    var field = this.fields[fieldName];
    if (!field) return;

    var currentlyHidden = field.classList.contains("is-hidden");
    if (!visible && !currentlyHidden) {
      this.clearField(fieldName);
    }

    field.classList.toggle("is-hidden", !visible);
  };

  DoorAddonConfigurator.prototype.clearField = function (fieldName) {
    var field = this.fields[fieldName];
    if (!field) return;

    field.querySelectorAll("[data-choice]").forEach(function (button) {
      button.classList.remove("is-selected");
      button.setAttribute("aria-pressed", "false");
    });

    field.querySelectorAll("[data-input]").forEach(function (input) {
      input.value = "";
    });

    var keys = FIELD_KEYS[fieldName] || [fieldName];
    keys.forEach(
      function (key) {
        delete this.state[key];
        this.hideError(key);
      }.bind(this)
    );

    if (fieldName === "prep_hinge_custom_measurements") {
      this.clearHingePhoto();
    }
  };

  DoorAddonConfigurator.prototype.render = function () {
    this.renderPathSelection();
    this.renderWorkflow();
    this.updatePricing();
  };

  DoorAddonConfigurator.prototype.renderPathSelection = function () {
    var currentPath = this.state.path;

    this.container.querySelectorAll("[data-path-option]").forEach(function (button) {
      button.classList.toggle("is-selected", button.value === currentPath);
      button.setAttribute("aria-pressed", button.value === currentPath ? "true" : "false");
    });

    if (this.pathResetButton) {
      this.pathResetButton.classList.toggle("is-hidden", !currentPath);
    }
  };

  DoorAddonConfigurator.prototype.renderWorkflow = function () {
    var path = this.state.path;
    var visibleMap = {};

    this.container.querySelectorAll("[data-workflow]").forEach(function (workflow) {
      workflow.classList.add("is-hidden");
    });

    if (path) {
      var activeWorkflow = this.container.querySelector('[data-workflow="' + path + '"]');
      if (activeWorkflow) activeWorkflow.classList.remove("is-hidden");

      if (path === "frame_set") visibleMap = this.renderFrameSetFlow();
      if (path === "door_prep") visibleMap = this.renderDoorPrepFlow();
      if (path === "custom_height") visibleMap = this.renderCustomHeightOnlyFlow();
    }

    Object.keys(this.fields).forEach(
      function (fieldName) {
        this.setFieldVisibility(fieldName, Boolean(visibleMap[fieldName]));
      }.bind(this)
    );
  };

  DoorAddonConfigurator.prototype.renderFrameSetFlow = function () {
    var state = this.state;
    var visibleMap = {
      frame_type: true
    };

    visibleMap.jamb_size = Boolean(state.frame_type);
    visibleMap.frame_lock_prep = Boolean(state.jamb_size);
    visibleMap.frame_swing = Boolean(state.frame_lock_prep);
    visibleMap.frame_hinges = Boolean(state.frame_swing);
    visibleMap.frame_hinge_finish = state.frame_hinges === "yes";

    var hingesCompleted =
      state.frame_hinges === "no" ||
      (state.frame_hinges === "yes" && Boolean(state.frame_hinge_finish));

    visibleMap.frame_custom_height_toggle = Boolean(state.frame_hinges) && hingesCompleted;
    visibleMap.frame_custom_height_value = state.frame_custom_height_toggle === "yes";

    return visibleMap;
  };

  DoorAddonConfigurator.prototype.renderDoorPrepFlow = function () {
    var state = this.state;
    var visibleMap = {
      prep_hinge_toggle: true
    };

    visibleMap.prep_hinge_type = state.prep_hinge_toggle === "yes";
    visibleMap.prep_hinge_custom_measurements = state.prep_hinge_type === "custom";

    var hingePrepComplete =
      state.prep_hinge_toggle === "no" ||
      (state.prep_hinge_toggle === "yes" && Boolean(state.prep_hinge_type));

    visibleMap.prep_lock_toggle = hingePrepComplete;
    visibleMap.prep_lock_type = state.prep_lock_toggle === "yes";
    visibleMap.prep_lock_custom_measurement = state.prep_lock_type === "custom";

    var lockPrepComplete =
      state.prep_lock_toggle === "no" ||
      (state.prep_lock_toggle === "yes" && Boolean(state.prep_lock_type));

    // If user declined BOTH hinge prep AND lock prep, skip swing/hinges/finish
    // and jump straight to the custom height question.
    var bothPrepsSkipped =
      state.prep_hinge_toggle === "no" && state.prep_lock_toggle === "no";

    if (bothPrepsSkipped) {
      visibleMap.prep_swing = false;
      visibleMap.prep_hinges = false;
      visibleMap.prep_hinge_finish = false;
      visibleMap.prep_custom_height_toggle = true;
      visibleMap.prep_custom_height_value = state.prep_custom_height_toggle === "yes";
      return visibleMap;
    }

    visibleMap.prep_swing = hingePrepComplete && Boolean(state.prep_lock_toggle) && lockPrepComplete;
    visibleMap.prep_hinges = Boolean(state.prep_swing);
    visibleMap.prep_hinge_finish = state.prep_hinges === "yes";

    var hingesComplete =
      state.prep_hinges === "no" ||
      (state.prep_hinges === "yes" && Boolean(state.prep_hinge_finish));

    visibleMap.prep_custom_height_toggle = Boolean(state.prep_hinges) && hingesComplete;
    visibleMap.prep_custom_height_value = state.prep_custom_height_toggle === "yes";

    return visibleMap;
  };

  DoorAddonConfigurator.prototype.renderCustomHeightOnlyFlow = function () {
    return {
      only_custom_height_value: true
    };
  };

  DoorAddonConfigurator.prototype.bindQuantityListeners = function () {
    // The theme's quantity stepper (quantity-counter) dispatches a NON-bubbling
    // "change" on the field, so the delegated form/productInfo listeners never
    // see stepper clicks — but product-info.js hears it via its own direct
    // field listener and rewrites the Add to Cart price to base x qty, wiping
    // the options. Listen on the field directly and re-render on the next
    // frame so the full configurator total always wins the last write.
    var scope = this.productInfo || this.form;
    if (!scope) return;

    var fields = scope.querySelectorAll("[data-quantity-field], input[name='quantity']");
    var self = this;

    Array.prototype.forEach.call(fields, function (field) {
      if (field.__exosDoorQtyBound) return;
      field.__exosDoorQtyBound = true;
      field.addEventListener("change", function () {
        var raf =
          window.requestAnimationFrame ||
          function (cb) {
            setTimeout(cb, 16);
          };
        raf(function () {
          self.updatePricing();
        });
      });
    });
  };

  DoorAddonConfigurator.prototype.getQuantity = function () {
    var qtyInput = this.productInfo
      ? this.productInfo.querySelector("[data-quantity-field]")
      : null;

    if (qtyInput) return Math.max(parseNumber(qtyInput.value, 1), 1);

    var formQty = this.form.querySelector("[name='quantity']");
    if (formQty) return Math.max(parseNumber(formQty.value, 1), 1);

    return 1;
  };

  DoorAddonConfigurator.prototype.getCurrentVariantId = function () {
    var variantInput = this.form.querySelector('input[name="id"]');
    return parseNumber(variantInput ? variantInput.value : 0, 0);
  };

  DoorAddonConfigurator.prototype.getCurrentVariantPrice = function () {
    var variantId = this.getCurrentVariantId();
    if (variantId && Object.prototype.hasOwnProperty.call(this.baseVariantPrices, String(variantId))) {
      return parseNumber(this.baseVariantPrices[String(variantId)], 0);
    }

    var formWrapper = this.productInfo
      ? this.productInfo.querySelector("[data-form-wrapper]")
      : null;
    if (formWrapper && formWrapper.dataset.variantPrice) {
      return parseNumber(formWrapper.dataset.variantPrice, 0);
    }

    return 0;
  };

  DoorAddonConfigurator.prototype.isDoubleDoorSelected = function () {
    if (this.state.path === "frame_set" && this.state.frame_swing === DOUBLE_DOOR_VALUE) {
      return true;
    }

    if (this.state.path === "door_prep" && this.state.prep_swing === DOUBLE_DOOR_VALUE) {
      return true;
    }

    return false;
  };

  DoorAddonConfigurator.prototype.getMainDoorQuantity = function () {
    var quantity = this.getQuantity();
    return this.isDoubleDoorSelected() ? quantity * 2 : quantity;
  };

  DoorAddonConfigurator.prototype.shouldDoubleAddonKey = function (addonKey) {
    return Boolean(DOUBLE_MULTIPLIED_ADDON_KEYS[addonKey]);
  };

  DoorAddonConfigurator.prototype.getAddonQuantityForKey = function (addonKey) {
    var quantity = this.getQuantity();
    if (this.isDoubleDoorSelected() && this.shouldDoubleAddonKey(addonKey)) {
      return quantity * 2;
    }

    return quantity;
  };

  DoorAddonConfigurator.prototype.collectAddonKeys = function () {
    var state = this.state;
    var selectedKeys = [];

    if (state.path === "frame_set") {
      // Frame pricing is combination-based: frame type + jamb size = one add-on product.
      if (state.frame_type && state.jamb_size) {
        if (state.frame_type === "mdf" && state.jamb_size === "4_5_8") {
          selectedKeys.push("frame_mdf_4_58");
        }
        if (state.frame_type === "mdf" && state.jamb_size === "6_5_8") {
          selectedKeys.push("frame_mdf_6_58");
        }
        if (state.frame_type === "fj_pine" && state.jamb_size === "4_5_8") {
          selectedKeys.push("frame_fj_pine_4_58");
        }
        if (state.frame_type === "fj_pine" && state.jamb_size === "6_5_8") {
          selectedKeys.push("frame_fj_pine_6_58");
        }
      }

      // Complete Door Frame Set always includes Standard Prep, regardless of Lock Prep choice.
      selectedKeys.push("prep_standard");
      if (state.frame_hinges === "yes") {
        if (state.frame_hinge_finish === "black") selectedKeys.push("hinges_black");
        if (state.frame_hinge_finish === "satin_nickel") {
          selectedKeys.push("hinges_satin_nickel");
        }
      }
      if (state.frame_custom_height_toggle === "yes") {
        selectedKeys.push("custom_height_cutdown");
      }
    }

    if (state.path === "door_prep") {
      var prepType = "none";
      var hingeType = state.prep_hinge_toggle === "yes" ? state.prep_hinge_type : "none";
      var lockType = state.prep_lock_toggle === "yes" ? state.prep_lock_type : "none";

      if (hingeType === "custom" || lockType === "custom") prepType = "custom";
      else if (hingeType === "standard" || lockType === "standard") prepType = "standard";

      if (prepType === "custom") selectedKeys.push("prep_custom");
      if (prepType === "standard") selectedKeys.push("prep_standard");

      if (state.prep_hinges === "yes") {
        if (state.prep_hinge_finish === "black") selectedKeys.push("hinges_black");
        if (state.prep_hinge_finish === "satin_nickel") {
          selectedKeys.push("hinges_satin_nickel");
        }
      }

      if (state.prep_custom_height_toggle === "yes") {
        selectedKeys.push("custom_height_cutdown");
      }
    }

    if (state.path === "custom_height") {
      selectedKeys.push("custom_height_cutdown");
    }

    return Array.from(new Set(selectedKeys));
  };

  DoorAddonConfigurator.prototype.getPricingTypeForAddonKey = function (addonKey) {
    if (addonKey.indexOf("frame_") === 0) return "frame";
    if (addonKey.indexOf("prep_") === 0) return "prep";
    if (addonKey.indexOf("hinges_") === 0) return "hinges";
    if (addonKey === "custom_height_cutdown") return "custom_height";
    return "other";
  };

  DoorAddonConfigurator.prototype.updatePricing = function () {
    if (!this.pricingList || !this.pricingTotal || !this.pricingEmpty) return;
    if (this.isResetCollapseInProgress) return;

    // Self-healing: theme section re-renders can swap the quantity field DOM,
    // dropping the direct listener. Re-bind here (no-op when already bound).
    this.bindQuantityListeners();

    if (this.getCurrentVariantId()) {
      this.clearSizeWarningState();
    }

    var addonKeys = this.collectAddonKeys();
    var baseQuantity = this.getQuantity();
    var baseVariantPrice = this.getCurrentVariantPrice();
    var totalAddonRelated = 0;
    var rowsByType = {
      frame: null,
      prep: null,
      hinges: null,
      custom_height: null
    };
    var orderedTypes = ["frame", "prep", "hinges", "custom_height"];

    this.pricingList.innerHTML = "";

    addonKeys.forEach(
      function (key) {
        var addon = this.addonProducts[key];
        if (!addon) return;

        var addonQuantity = this.getAddonQuantityForKey(key);
        if (addonQuantity < 1) return;

        var amount = parseNumber(addon.price, 0) * addonQuantity;
        var type = this.getPricingTypeForAddonKey(key);
        if (type === "other") return;

        if (!rowsByType[type]) {
          rowsByType[type] = {
            label: addon.label,
            quantity: addonQuantity,
            amount: amount
          };
          return;
        }

        rowsByType[type].amount += amount;
        rowsByType[type].quantity += addonQuantity;
      }.bind(this)
    );

    if (this.isDoubleDoorSelected()) {
      var extraDoorAmount = baseVariantPrice * baseQuantity;
      if (extraDoorAmount > 0) {
        totalAddonRelated += extraDoorAmount;

        var extraDoorItem = document.createElement("li");
        extraDoorItem.innerHTML =
          "<span>Extra Door Slab (Double Door)" +
          (baseQuantity > 1 ? " x" + baseQuantity : "") +
          "</span><strong>" +
          asMoney(extraDoorAmount) +
          "</strong>";
        this.pricingList.appendChild(extraDoorItem);
      }
    }

    orderedTypes.forEach(
      function (type) {
        var row = rowsByType[type];
        if (!row) return;

        totalAddonRelated += row.amount;

        var item = document.createElement("li");
        item.innerHTML =
          "<span>" +
          row.label +
          (row.quantity > 1 ? " x" + row.quantity : "") +
          "</span><strong>" +
          asMoney(row.amount) +
          "</strong>";
        this.pricingList.appendChild(item);
      }.bind(this)
    );

    var hasPricingRows = this.pricingList.children.length > 0;

    this.pricingEmpty.style.display = hasPricingRows ? "none" : "";
    this.pricingTotal.textContent = asMoney(totalAddonRelated);

    var fullTotal = baseVariantPrice * baseQuantity + totalAddonRelated;
    this.updateSubmitButtonPrice(fullTotal);
  };

  DoorAddonConfigurator.prototype.updateSubmitButtonPrice = function (fullTotal) {
    if (!this.submitButton || !document.body.contains(this.submitButton)) {
      this.submitButton = this.form.querySelector('button[type="submit"][name="add"]');
    }

    if (!this.submitButton) return;

    var submitPrice = this.submitButton.querySelector("[data-product-price]");
    if (!submitPrice) return;

    submitPrice.textContent = asMoney(fullTotal);
    submitPrice.classList.remove("hidden");

    var submitComparePrice = this.submitButton.querySelector("[data-compare-price]");
    if (submitComparePrice) {
      submitComparePrice.classList.add("hidden");
      submitComparePrice.style.display = "none";
    }
  };

  DoorAddonConfigurator.prototype.hideError = function (fieldKey) {
    var errorEl = this.errors[fieldKey];
    if (!errorEl) return;
    errorEl.classList.add("is-hidden");
    errorEl.textContent = "";
  };

  DoorAddonConfigurator.prototype.showError = function (fieldKey, message) {
    var errorEl = this.errors[fieldKey];
    if (!errorEl) return;
    errorEl.classList.remove("is-hidden");
    errorEl.textContent = message;
  };

  DoorAddonConfigurator.prototype.clearErrors = function () {
    Object.keys(this.errors).forEach(
      function (key) {
        this.hideError(key);
      }.bind(this)
    );
  };

  DoorAddonConfigurator.prototype.showSubmitError = function (message) {
    if (!this.submitError) return;
    this.submitError.classList.remove("is-hidden");
    this.submitError.textContent = message;
  };

  DoorAddonConfigurator.prototype.hideSubmitError = function () {
    if (!this.submitError) return;
    this.submitError.classList.add("is-hidden");
    this.submitError.textContent = "";
  };

  DoorAddonConfigurator.prototype.validateCustomHeight = function (fieldKey) {
    var value = this.state[fieldKey];
    var parsed = parseDimension(value);

    if (!value) {
      this.showError(fieldKey, "Please enter a custom height.");
      return { valid: false, decimal: null };
    }

    if (!parsed.valid) {
      this.showError(
        fieldKey,
        "Use a valid format like 77, 77.5, 77-1/2, or 77 1/2."
      );
      return { valid: false, decimal: null };
    }

    if (parsed.decimal < 75 || parsed.decimal > 80) {
      this.showError(fieldKey, "Custom height must be between 75 and 80 inches.");
      return { valid: false, decimal: null };
    }

    this.hideError(fieldKey);
    return { valid: true, decimal: parsed.decimal };
  };

  DoorAddonConfigurator.prototype.validateMeasurement = function (fieldKey, required) {
    var value = this.state[fieldKey];
    if (!value && !required) {
      this.hideError(fieldKey);
      return { valid: true, decimal: null };
    }

    if (!value && required) {
      this.showError(fieldKey, "This measurement is required.");
      return { valid: false, decimal: null };
    }

    var parsed = parseDimension(value);
    if (!parsed.valid) {
      this.showError(
        fieldKey,
        "Use a valid format like 44, 44.75, 44-3/4, or 44 3/4."
      );
      return { valid: false, decimal: null };
    }

    this.hideError(fieldKey);
    return { valid: true, decimal: parsed.decimal };
  };

  // Validates a single hinge mark — the distance from the top of the door to
  // the top of the hinge. Optional hinges (e.g. the middle) may be left blank.
  // Each mark must land inside its own band [min, max] (inches) so the three
  // hinges stay in order and can't be typed into the wrong field:
  // top 1-15, middle 16-50, bottom 51-80.
  DoorAddonConfigurator.prototype.validateHingeMark = function (key, required, min, max) {
    var value = this.state[key];

    if (!value && !required) {
      this.hideError(key);
      return { valid: true, empty: true };
    }

    if (!value && required) {
      this.showError(key, "This measurement is required.");
      return { valid: false, empty: true };
    }

    var parsed = parseDimension(value);
    if (!parsed.valid) {
      this.showError(key, "Use a valid format like 7, 7.25, 7-1/4, or 7 1/4.");
      return { valid: false, empty: false };
    }

    if (parsed.decimal < min || parsed.decimal > max) {
      this.showError(
        key,
        "Enter a measurement between " + min + " and " + max + " inches."
      );
      return { valid: false, empty: false };
    }

    this.hideError(key);
    return { valid: true, empty: false };
  };

  // Builds a shop-floor-friendly hinge property string from the value the
  // customer typed, e.g. 7 -> 7".
  function formatHingeMark(raw) {
    var v = String(raw == null ? "" : raw).replace(/["']/g, "").trim();
    return v + '"';
  }

  // ----- Hinge photo (required on custom hinge prep) -----

  DoorAddonConfigurator.prototype.getHingePhotoInput = function () {
    return this.container.querySelector("[data-hinge-photo-input]");
  };

  DoorAddonConfigurator.prototype.hasHingePhoto = function () {
    var input = this.getHingePhotoInput();
    return Boolean(input && input.files && input.files.length > 0);
  };

  DoorAddonConfigurator.prototype.handleHingePhotoChange = function (input) {
    var nameEl = this.container.querySelector("[data-hinge-photo-name]");
    var previewEl = this.container.querySelector("[data-hinge-photo-preview]");
    var file = input.files && input.files[0];

    function clearMeta() {
      if (nameEl) {
        nameEl.classList.add("is-hidden");
        nameEl.textContent = "";
      }
      if (previewEl) {
        previewEl.classList.add("is-hidden");
        previewEl.removeAttribute("src");
      }
    }

    if (!file) {
      clearMeta();
      return;
    }

    var nameLower = (file.name || "").toLowerCase();
    var isImage =
      /^image\//.test(file.type || "") ||
      /\.(jpe?g|png|gif|webp|heic|heif|bmp|tiff?)$/.test(nameLower);
    if (!isImage) {
      input.value = "";
      clearMeta();
      this.showError("hinge_photo", "Please choose an image file (JPG, PNG, HEIC, etc.).");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      input.value = "";
      clearMeta();
      this.showError("hinge_photo", "That photo is over 10 MB — please use a smaller image.");
      return;
    }

    this.hideError("hinge_photo");
    this.hideSubmitError();

    if (nameEl) {
      nameEl.classList.remove("is-hidden");
      nameEl.textContent = file.name;
    }
    if (previewEl && window.URL && typeof window.URL.createObjectURL === "function") {
      previewEl.src = window.URL.createObjectURL(file);
      previewEl.classList.remove("is-hidden");
    }
  };

  DoorAddonConfigurator.prototype.clearHingePhoto = function () {
    var input = this.getHingePhotoInput();
    if (input) input.value = "";
    var nameEl = this.container.querySelector("[data-hinge-photo-name]");
    if (nameEl) {
      nameEl.classList.add("is-hidden");
      nameEl.textContent = "";
    }
    var previewEl = this.container.querySelector("[data-hinge-photo-preview]");
    if (previewEl) {
      previewEl.classList.add("is-hidden");
      previewEl.removeAttribute("src");
    }
    this.hideError("hinge_photo");
  };

  DoorAddonConfigurator.prototype.validate = function () {
    this.clearErrors();

    var state = this.state;
    var props = {};

    if (state.path === "frame_set") {
      if (!state.frame_type) return { valid: false, message: "Please select Frame Type." };
      if (!state.jamb_size) return { valid: false, message: "Please select Jamb Size." };
      if (!state.frame_lock_prep) return { valid: false, message: "Please select Lock Prep." };
      if (!state.frame_swing) return { valid: false, message: "Please select Swing Direction." };
      if (!state.frame_hinges) return { valid: false, message: "Please select Hinges." };
      if (state.frame_hinges === "yes" && !state.frame_hinge_finish) {
        return { valid: false, message: "Please select a hinge finish." };
      }
      if (!state.frame_custom_height_toggle) {
        return { valid: false, message: "Please select Custom Height option." };
      }

      if (state.frame_custom_height_toggle === "yes") {
        var frameHeightValidation = this.validateCustomHeight("frame_custom_height_value");
        if (!frameHeightValidation.valid) {
          return { valid: false, message: "Please correct the custom height value." };
        }
      }

      props["Add-On Path"] = "Complete Door Frame Set";
      props["Frame Type"] = state.frame_type === "mdf" ? "MDF" : "FJ Pine";
      props["Jamb Size"] = state.jamb_size === "4_5_8" ? '4 5/8"' : '6 5/8"';
      props["Lock Prep"] = state.frame_lock_prep === "yes" ? "Standard" : "No";
      props["Swing"] = state.frame_swing;
      props["Hinges"] = state.frame_hinges === "yes" ? "Yes" : "No";
      if (state.frame_hinges === "yes") {
        props["Hinge Finish"] =
          state.frame_hinge_finish === "black" ? "Black" : "Satin Nickel";
      }
      props["Custom Height"] =
        state.frame_custom_height_toggle === "yes"
          ? state.frame_custom_height_value
          : "No";
    }

    if (state.path === "door_prep") {
      if (!state.prep_hinge_toggle) {
        return { valid: false, message: "Please select Hinge Prep." };
      }
      if (state.prep_hinge_toggle === "yes" && !state.prep_hinge_type) {
        return { valid: false, message: "Please select Hinge Prep Type." };
      }

      var topHingeMark = null;
      var middleHingeMark = null;
      var bottomHingeMark = null;
      if (state.prep_hinge_type === "custom") {
        topHingeMark = this.validateHingeMark("top_hinge_top", true, 1, 15);
        middleHingeMark = this.validateHingeMark("middle_hinge_top", false, 16, 50);
        bottomHingeMark = this.validateHingeMark("bottom_hinge_top", true, 51, 80);
        if (!topHingeMark.valid || !middleHingeMark.valid || !bottomHingeMark.valid) {
          return { valid: false, message: "Please correct hinge prep measurements." };
        }
        if (!this.hasHingePhoto()) {
          this.showError("hinge_photo", "Please add a photo of one of your hinges.");
          return { valid: false, message: "Please add a photo of one of your hinges." };
        }
      }

      if (!state.prep_lock_toggle) {
        return { valid: false, message: "Please select Lock Prep." };
      }
      if (state.prep_lock_toggle === "yes" && !state.prep_lock_type) {
        return { valid: false, message: "Please select Lock Prep Type." };
      }

      if (state.prep_lock_type === "custom") {
        var lockResult = this.validateMeasurement("lock_centre_location", true);
        if (!lockResult.valid) {
          return { valid: false, message: "Please correct Lock Centre Location." };
        }
      }

      // If both preps were declined, skip swing/hinges validation entirely.
      var bothPrepsSkippedValidate =
        state.prep_hinge_toggle === "no" && state.prep_lock_toggle === "no";

      if (!bothPrepsSkippedValidate) {
        if (!state.prep_swing) {
          return { valid: false, message: "Please select Swing Direction." };
        }
        if (!state.prep_hinges) {
          return { valid: false, message: "Please select Hinges." };
        }
        if (state.prep_hinges === "yes" && !state.prep_hinge_finish) {
          return { valid: false, message: "Please select a hinge finish." };
        }
      }

      if (!state.prep_custom_height_toggle) {
        return { valid: false, message: "Please select Custom Height option." };
      }

      if (state.prep_custom_height_toggle === "yes") {
        var prepHeightValidation = this.validateCustomHeight("prep_custom_height_value");
        if (!prepHeightValidation.valid) {
          return { valid: false, message: "Please correct the custom height value." };
        }
      }

      props["Add-On Path"] = "Door Prep Machining";
      props["Hinge Prep"] = state.prep_hinge_toggle === "yes" ? "Yes" : "No";
      if (state.prep_hinge_toggle === "yes") {
        props["Hinge Prep Type"] =
          state.prep_hinge_type === "custom" ? "Custom" : "Standard";
      }
      if (state.prep_hinge_type === "custom") {
        props["Top Hinge"] = formatHingeMark(state.top_hinge_top);
        props["Bottom Hinge"] = formatHingeMark(state.bottom_hinge_top);
        if (middleHingeMark && !middleHingeMark.empty) {
          props["Middle Hinge"] = formatHingeMark(state.middle_hinge_top);
        }
      }

      props["Lock Prep"] = state.prep_lock_toggle === "yes" ? "Yes" : "No";
      if (state.prep_lock_toggle === "yes") {
        props["Lock Prep Type"] =
          state.prep_lock_type === "custom" ? "Custom" : "Standard";
      }
      if (state.prep_lock_type === "custom") {
        props["Lock Centre Location"] = state.lock_centre_location;
      }

      // Only stamp swing/hinges properties on the cart line if the user
      // actually went through those steps.
      if (!bothPrepsSkippedValidate) {
        props["Swing"] = state.prep_swing;
        props["Hinges"] = state.prep_hinges === "yes" ? "Yes" : "No";
        if (state.prep_hinges === "yes") {
          props["Hinge Finish"] =
            state.prep_hinge_finish === "black" ? "Black" : "Satin Nickel";
        }
      }

      props["Custom Height"] =
        state.prep_custom_height_toggle === "yes"
          ? state.prep_custom_height_value
          : "No";
    }

    if (state.path === "custom_height") {
      var heightOnlyValidation = this.validateCustomHeight("only_custom_height_value");
      if (!heightOnlyValidation.valid) {
        return { valid: false, message: "Please correct the custom height value." };
      }

      props["Add-On Path"] = "Custom Height Cutdown";
      props["Custom Height"] = state.only_custom_height_value;
    }

    return { valid: true, message: "", properties: props };
  };

  DoorAddonConfigurator.prototype.collectBaseFormProperties = function (formData) {
    var props = {};

    formData.forEach(function (value, key) {
      if (!key.startsWith("properties[")) return;
      var propName = key.replace(/^properties\[/, "").replace(/\]$/, "");
      var propNameLower = String(propName || "").toLowerCase();
      if (INTERNAL_PROPERTY_BLOCKLIST[propName]) return;
      if (/^_door/.test(propNameLower)) return;
      if (
        propNameLower.indexOf("door config id") !== -1 ||
        propNameLower.indexOf("door main item") !== -1 ||
        propNameLower.indexOf("door main multiplier") !== -1 ||
        propNameLower.indexOf("door add-on") !== -1
      ) {
        return;
      }
      if (/decimal/i.test(propName)) return;
      props[propName] = value;
    });

    return props;
  };

  DoorAddonConfigurator.prototype.buildCartPayload = function (addonProperties) {
    var formData = new FormData(this.form);
    var variantId = parseNumber(formData.get("id"), 0);
    var mainDoorQuantity = this.getMainDoorQuantity();
    var sellingPlan = formData.get("selling_plan");
    var configId =
      "door-config-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 8);

    if (!variantId) {
      return {
        valid: false,
        code: "missing_variant",
        message: "Please select a valid size before adding to cart."
      };
    }

    var baseProperties = this.collectBaseFormProperties(formData);
    var mergedProperties = Object.assign({}, baseProperties, addonProperties, {
      "_Door Config ID": configId
    });
    var addonKeys = this.collectAddonKeys();

    var items = [
      {
        id: variantId,
        quantity: mainDoorQuantity,
        properties: mergedProperties
      }
    ];

    if (sellingPlan) {
      items[0].selling_plan = sellingPlan;
    }

    for (var i = 0; i < addonKeys.length; i++) {
      var addonKey = addonKeys[i];
      var addon = this.addonProducts[addonKey];

      if (!addon || !addon.variant_id) {
        return {
          valid: false,
          message:
            "Add-on product is not configured in theme settings: " +
            (addon ? addon.label : addonKey) +
            "."
        };
      }

      items.push({
        id: parseNumber(addon.variant_id, 0),
        quantity: this.getAddonQuantityForKey(addonKey),
        properties: {
          "_Door Add-On": "Yes",
          "_Door Config ID": configId,
          "_Door Add-On Multiplier": String(
            this.isDoubleDoorSelected() && this.shouldDoubleAddonKey(addonKey) ? 2 : 1
          )
        }
      });
    }

    var hingePhotoFile = null;
    if (
      this.state.path === "door_prep" &&
      this.state.prep_hinge_type === "custom"
    ) {
      var photoInput = this.getHingePhotoInput();
      if (photoInput && photoInput.files && photoInput.files[0]) {
        hingePhotoFile = photoInput.files[0];
      }
    }

    return { valid: true, items: items, hingePhotoFile: hingePhotoFile };
  };

  DoorAddonConfigurator.prototype.submitCartPayload = function (items) {
    if (this.submitButton) {
      this.submitButton.classList.add("is-loading");
      this.submitButton.setAttribute("disabled", "disabled");
    }

    var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || "/cart/add";
    if (!/\.js$/.test(addUrl)) addUrl += ".js";

    fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (response) {
          if (response && response.status) {
            this.showSubmitError(response.description || "Unable to add items to cart.");
            this.resetSubmitButton();
            return;
          }

          document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
          document.dispatchEvent(
            new CustomEvent("exos:cart:added", {
              bubbles: true,
              detail: {
                source: "door-configurator",
                button: this.submitButton
              }
            })
          );
          this.resetSubmitButton();
        }.bind(this)
      )
      .catch(
        function () {
          this.showSubmitError("Unable to add items to cart. Please try again.");
          this.resetSubmitButton();
        }.bind(this)
      );
  };

  // Custom-hinge orders carry a customer photo, which Shopify only accepts as a
  // multipart upload at add-to-cart time. So we add the main door line on its own
  // via FormData (photo attached), then add the add-on lines via the normal JSON
  // call. If the add-ons fail, we roll the door back so the cart is never partial.
  DoorAddonConfigurator.prototype.submitCartPayloadWithPhoto = function (items, photoFile) {
    if (this.submitButton) {
      this.submitButton.classList.add("is-loading");
      this.submitButton.setAttribute("disabled", "disabled");
    }

    var self = this;
    var routes = (window.theme && window.theme.routes) || {};
    var addUrl = routes.cart_add_url || "/cart/add";
    if (!/\.js$/.test(addUrl)) addUrl += ".js";
    var changeUrl = routes.cart_change_url || "/cart/change";
    if (!/\.js$/.test(changeUrl)) changeUrl += ".js";

    var mainItem = items[0];
    var addonItems = items.slice(1);

    var fd = new FormData();
    fd.append("id", mainItem.id);
    fd.append("quantity", mainItem.quantity);
    if (mainItem.selling_plan) fd.append("selling_plan", mainItem.selling_plan);
    var mainProps = mainItem.properties || {};
    Object.keys(mainProps).forEach(function (key) {
      fd.append("properties[" + key + "]", mainProps[key]);
    });
    fd.append("properties[Hinge Photo]", photoFile, photoFile.name);

    function readJson(response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    }

    var addonsFailedMessage =
      "Your hinge photo uploaded, but we couldn't add the door options. Please try again.";

    fetch(addUrl, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
      body: fd
    })
      .then(readJson)
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          self.showSubmitError(
            (res.data && (res.data.description || res.data.message)) ||
              "Unable to add your door to the cart. Please try again."
          );
          self.resetSubmitButton();
          return;
        }

        var mainKey = res.data && (res.data.key || res.data.id);

        if (!addonItems.length) {
          self.finishCartAdd();
          return;
        }

        fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json"
          },
          body: JSON.stringify({ items: addonItems })
        })
          .then(readJson)
          .then(function (res2) {
            if (!res2.ok || (res2.data && res2.data.status)) {
              self.rollbackCartLine(changeUrl, mainKey, function () {
                self.showSubmitError(addonsFailedMessage);
                self.resetSubmitButton();
              });
              return;
            }
            self.finishCartAdd();
          })
          .catch(function () {
            self.rollbackCartLine(changeUrl, mainKey, function () {
              self.showSubmitError(addonsFailedMessage);
              self.resetSubmitButton();
            });
          });
      })
      .catch(function () {
        self.showSubmitError("Unable to add your door to the cart. Please try again.");
        self.resetSubmitButton();
      });
  };

  DoorAddonConfigurator.prototype.rollbackCartLine = function (changeUrl, key, done) {
    if (!key) {
      if (done) done();
      return;
    }
    fetch(changeUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: String(key), quantity: 0 })
    })
      .then(function () {
        if (done) done();
      })
      .catch(function () {
        if (done) done();
      });
  };

  DoorAddonConfigurator.prototype.finishCartAdd = function () {
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
    document.dispatchEvent(
      new CustomEvent("exos:cart:added", {
        bubbles: true,
        detail: { source: "door-configurator", button: this.submitButton }
      })
    );
    this.resetSubmitButton();
  };

  DoorAddonConfigurator.prototype.resetSubmitButton = function () {
    if (!this.submitButton) return;
    this.submitButton.classList.remove("is-loading");
    this.submitButton.removeAttribute("disabled");
  };

  function initDoorAddons(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll("[data-door-addon-configurator]");

    containers.forEach(function (container) {
      if (initialized.has(container)) return;
      var instance = new DoorAddonConfigurator(container);
      if (instance.form) {
        initialized.add(container);
        configuratorInstances.set(container, instance);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDoorAddons(document);
  });

  document.addEventListener("theme:product-info:loaded", function (event) {
    initDoorAddons(event.target || document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initDoorAddons(event.target || document);
  });

  document.addEventListener("exos:door-configurator:reset", function (event) {
    var formId = event && event.detail ? event.detail.formId : null;
    if (!formId) return;

    document.querySelectorAll("[data-door-addon-configurator]").forEach(function (container) {
      var instance = configuratorInstances.get(container);
      if (!instance || !instance.form || instance.form.id !== formId) return;
      instance.animateResetToBlank();
    });
  });
})();

